import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-k', 'IconLetterK', [
  ['path', { d: 'M7 4l0 16', key: 'svg-0' }],
  ['path', { d: 'M7 12h2l8 -8', key: 'svg-1' }],
  ['path', { d: 'M9 12l8 8', key: 'svg-2' }],
]);
